import Vue from "vue";
import router, { setupRouterGuard } from "./router";
import store from "./store";
import App from "./App.vue";
import mcModel from "@maersk-global/mds-vue-mc-model";
import { MaerskVueApp, VueLanguageHandler, MaerskGAEventsDispatcher } from "@maersk/vue-plugin-core";
import GAConfig from "@/lib/googleAnalyticsConfig";
import { loadSLN, IGN_NAV_STATE } from "@/lib/SLN.config.js";
import PortalVue from "portal-vue";
import { constants } from "@/lib/CONSTANTS.js";
import { initializeMsal } from "@/common/utils/auth/authRules";

Vue.use(PortalVue);
Vue.directive("mc-model", mcModel);
Vue.config.ignoredElements = [/^mc-/];

const config = {
  multiBranding: {
    maeuCSS: () => import("@/scss/maeu.scss")
  }
};

//Setting SLN Nav
config.SKIP_GLOBAL_NAV = IGN_NAV_STATE === "disable" ? true : false; //disable IGN header and Footer all-together

// Function to check if the current URL is from Azure portal
function isAzurePortalUrl() {
  if (typeof window !== "undefined" && window.location) {
    const currentHost = window.location.hostname;

    // Check if it's an Azure deployment (azurewebsites.net or its subdomains)
    return currentHost === "azurewebsites.net" || currentHost.endsWith(".azurewebsites.net");
  }

  return false;
}

// Load SLN only if maintenance is off AND (Azure URL redirect is off OR not an Azure portal URL)
if (!constants.pageSettings.isMaintanenceON && !(constants.pageSettings.isAzureUrlRedirectON && isAzurePortalUrl())) {
  loadSLN();
}

if (process.env.NODE_ENV === "production") {
  Vue.config.devtools = false;
  Vue.config.debug = false;
  Vue.config.silent = true;
} else if (process.env.NODE_ENV === "development") {
  // These parameters are only used in localhost
  // Local vue config
  Vue.config.devtools = true;
  Vue.config.performance = true;
  //This is a switch to the branding
  config.brandParam = "maeu"; // values: 'seau', 'safm', 'maeu' or 'maei';
}

Vue.config.productionTip = false;

IGN_NAV_STATE !== "disable" && Vue.use(MaerskGAEventsDispatcher, GAConfig);
Vue.use(MaerskVueApp, config);

// i18n handler
Vue.use(VueLanguageHandler, {
  langFilePathWeb: "/locales", //web path
  langFilePathLocal: "/locales" // the local file path which refers to /public folder of your project
});

// Initialize app with MSAL authentication
(async () => {
  try {
    // Step 1: Initialize MSAL before anything else
    await initializeMsal();

    // Step 2: Set up router guard after MSAL is ready
    setupRouterGuard();

    // Step 3: Load language data
    await VueLanguageHandler.loadLanguageData();

    // Step 4: Mount Vue app
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#manifest_app");
  } catch (error) {
    // Application initialization failed
    // Error is silently caught to prevent app crash
  }
})();
